import Menu from './Menu.jsx';

export default Menu;


// WEBPACK FOOTER //
// ./src/components/Menu/index.jsx